export class AccountBalanceRow {
    currency: string;
    account: string;
    expectedBalance: number;
    statementBalance: number;
    balanceDifference: number;
    balanceDifferencePercentage: number;
    isStatementBalanceAccepted: boolean;
    isSignificantDifference: boolean;
}
